module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("We knew there was an astounding array of talent out there and the Jelly Roll Challenge was set to find out exactly where it was!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The criteria for the quilts was not that they had to be complex or difficult to make but that they had to make good use of the jelly roll fabrics in a design that would inspire others. Choosing the winning quilts was extremely difficult and we hope we have chosen designs that will inspire you to ‘have a go’ and unravel those beautifully packaged strips of fabric which we have come to love. The quilt designs certainly inspired us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The winning quilt featured on the front cover of this book, Be My Valentine, is a great quilt and a worthy winner. It is challenging – but we did call it a jelly roll ‘challenge’! You will find the quilt on page 96, so if you do not feel ready for it yet, you can progress through the book trying all the other superb designs first. Templates are used to make the quilt – cleverly placed on the jelly roll to make the most of every inch of fabric. We have, however, given a cushion variation which enables the shapes to be cut using an Omnigrid 96 ruler instead of templates. We do like to give you every option!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We have placed the quilts through the book in what we feel is the order of difficulty and certainly not in the placement of the competition. Thanks to everyone who took part in the Challenge – you have given us so much pleasure. The standard of the entries "), _c('br'), _vm._v("was very high and congratulations to the quilters whose quilts are included here. You should be feeling very proud of yourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of each chapter there is a variation of each quilt made by us, showing how the design might look with a different choice of fabrics. We had great fun making these variations – now it is your turn. Choose a pattern to try, and then another, and another and enjoy them as much as we did.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Pam and Nicky")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Here are the three gorgeous winning quilts of the Jelly Roll Challenge competition – Be My Valentine, Beach Hut Parade and Birthday Gift – showing just how versatile jelly rolls are, and how wonderful inventive quilters are.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/7-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/8-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/8-2.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a9a25e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781446350935_epub_int_r1.vue
// module id = 66
// module chunks = 0